<template>
  <i18n-t
    class="terms"
    keypath="fbsHub.meterReport.terms.text"
    scope="global"
    tag="p"
  >
    <template #privacyLink>
      <a
        :href="$t('shared.corporate.service.link.privacy.path')"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t("fbsHub.meterReport.terms.privacy") }}
      </a>
    </template>
    <template #conditionsLink>
      <a
        :href="$t('shared.corporate.service.link.conditions.path')"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t("fbsHub.meterReport.terms.conditions") }}
      </a>
    </template>
  </i18n-t>
</template>

<style scoped>
@import "Terms.css";
</style>
